import useIntl from './useIntl';

export { useIntl };
